'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity, text, attributes, options) {
  if (!options.suppressNoFollow) {
    attributes.rel = 'nofollow';
  }
  // if linkAttributeBlock is specified, call it to modify the attributes
  if (options.linkAttributeBlock) {
    options.linkAttributeBlock(entity, attributes);
  }
  // if linkTextBlock is specified, call it to get a new/modified link text
  if (options.linkTextBlock) {
    text = options.linkTextBlock(entity, text);
  }
  var d = {
    text: text,
    attr: (0, _tagAttrs2.default)(attributes)
  };
  return (0, _stringSupplant2.default)('<a#{attr}>#{text}</a>', d);
};

var _stringSupplant = require('./lib/stringSupplant');

var _stringSupplant2 = _interopRequireDefault(_stringSupplant);

var _tagAttrs = require('./tagAttrs');

var _tagAttrs2 = _interopRequireDefault(_tagAttrs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default']; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0